import React, { Component } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button'

import './wrapper-text-note-chart.style.css';

export class WrapperTextNoteChart extends Component {
    render() {
        return (
            <div className="note-chart">
                <Accordion className="accordin-custom-water-balance">
                    <Card>
                        <Card.Header className = "card-header-water-balance" style={{cursor: 'pointer'}}>
                            <Accordion.Toggle as={Card.Header} variant="link" eventKey="0" className="card-header-water-balance">
                                <p className="note-text"> <i>More infomation</i></p>
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <p className="note-text">Less than 4: Further loss reduction may be uneconomic unless there are shortages; careful analysis needed to identify cost-effective improvement</p>
                                <p className="note-text">4 to &lt; 8: Potential for marked improvements; consider pressure management, better active leakage control practices, and better network maintenance</p>
                                <p className="note-text">8 to &lt; 16: Poor leakage record; tolerable only if water is plentiful and cheap; even then, analyze level and nature of leakage and intensify leakage reduction efforts</p>
                                <p className="note-text" style={{ fontWeight: "bold"}}>16 or more: Very inefficient use of resources; leakage reduction programs imperative and high priority</p>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        )
    }
}

export default WrapperTextNoteChart
